import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ModalRightService {

    private _isCustomizerOpen$ = new BehaviorSubject<boolean>(false);
  isCustomizerOpen$ = this._isCustomizerOpen$.asObservable();

  private _sidebarData$ = new BehaviorSubject<{
    showTotals: boolean,
    showContactInfo: boolean,
    showDescription: boolean,
    noteText: string
  }>({
    showTotals: true,
    showContactInfo: true,
    showDescription: false,
    noteText: ''
  });

  sidebarData$ = this._sidebarData$.asObservable();

  open(data?: {
    showTotals?: boolean;
    showContactInfo?: boolean;
    showDescription?: boolean;
    noteText?: string;
  }) {
    const current = this._sidebarData$.getValue();
    this._sidebarData$.next({ ...current, ...data });
    this._isCustomizerOpen$.next(true);
    console.log('Service: customizer open set to true');
  }

  close() {
    console.log('Service CLOSE called');
    this._isCustomizerOpen$.next(false);
  }
}
